const hasWindow = typeof window !== 'undefined';
export class UserLocalStorage {
    constructor() {
        this.storage = {};
    }
    getDeprecatedItem(key) {
        var _a;
        if (!hasWindow)
            return;
        let settings;
        try {
            settings = JSON === null || JSON === void 0 ? void 0 : JSON.parse(((_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem('userSettings')) || '""');
        }
        catch (e) {
            settings = JSON === null || JSON === void 0 ? void 0 : JSON.parse('""');
        }
        return settings[key];
    }
    getItem(key) {
        var _a;
        if (!hasWindow)
            return;
        const item = (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem(key);
        if (!item)
            return this.getDeprecatedItem(key);
        try {
            return JSON.parse(item);
        }
        catch (_b) {
            return undefined;
        }
    }
    setItem(key, value) {
        var _a;
        if (!hasWindow)
            return;
        (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.setItem(key, JSON.stringify(value));
    }
}
//# sourceMappingURL=storage.utils.js.map